import React, { Component } from 'react';
import { ScrollSyncPane } from 'react-scroll-sync'
import { push } from 'react-router-redux'
import { NavLink } from 'react-router-dom'
import '../stylesheets/inventory.sass'

export default class Row extends Component {

  render() {
    return(
      <div className='customer_row'>
        <NavLink to={`/customer/${this.props.customer && this.props.customer.id}`}>
        { this.props.customer &&
          this.props.customer['attributes'] &&
        <div className='customer_row_wrapper'>
          <div className='customer_col_one'>
          </div>
          <div className='column-one customer-col name'>
            <div>
              { this.props.customer['attributes']['firstName']}
            </div>
            <div>
              &nbsp;
            </div>
            <div>
              { this.props.customer['attributes']['lastName']}
            </div>
          </div>
          <ScrollSyncPane>
            <div className='scroll'>
              <div className='customer-col half'>
                <div>
                  { this.props.customer['attributes']['email']}
                </div>
              </div>
              <div className='customer-col quarter-slim'>
                <div>
                  { this.props.customer['attributes']['phoneNumber']}
                </div>
              </div>
              <div className='customer-col quarter'>
                <div>
                  { this.props.customer['attributes']['streetAddress']}
                </div>
              </div>
              <div className='customer_col_last customer-col sixth'>
                <div>
                  { this.props.customer['attributes']['numberOfOrders']}
                </div>
              </div>
            </div>
          </ScrollSyncPane>
        </div>
        }
      </NavLink>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Customers/Row.jsx